import auth from "./auth";
import media from "./media";
import modals from "./modals";
import megaphones from "./megaphones";
import experiments from "./experiments";
import companyValuesReducer from "../../company_values/reducers";
import projectSupportsReducer from "../../project_supports/reducers";
import projectBookmarksReducer from "../../project_bookmarks/reducers";
import companyFollowingsReducer from "../../company_followings/reducers";

const reducers = {
  auth,
  media,
  modals,
  megaphones,
  experiments,
  company_values: companyValuesReducer,
  project_supports: projectSupportsReducer,
  project_bookmarks: projectBookmarksReducer,
  company_followings: companyFollowingsReducer,
};

export default reducers;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/index.ts